<template>
    <div class="bg-darkblue text-white d-flex align-center justify-space-between pa-2">

        <div class="text-body-1 font-weight-bold">{{ nom_coureur }}</div>

        <div v-if="!isFinished && !noDelete && !is_dossard_bourse_mode">
            <v-btn @click="openDeleteDialog()" color="red-darken-4" variant="flat"><v-icon
                    icon="mdi-delete"></v-icon></v-btn>
        </div>

    </div>

    <v-dialog width="500" max-width="100%" v-model="deleteDialog" scroll-strategy="none">
        <v-card>
            <v-card-text>
                <div class="text-body-1 text-center">
                    Etes-vous sûr de vouloir supprimer l'inscription de <br />
                    <b>{{ nom_coureur }}</b> ?
                </div>
                <div class="d-flex justify-center flex-wrap gap mt-2">
                    <v-btn color="dark-red" variant="text" @click="closeDeleteDialog()">Non</v-btn>
                    <v-btn color="dark-green" variant="text" @click="deleteInscription()">Oui</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>
import { useMainStore } from '@/stores/mainStore';
import { mapStores } from 'pinia';

export default {
    props: {
        inscription: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        isFinished: {
            type: Boolean,
            required: true
        },
        noDelete: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        ...mapStores(useMainStore),
        nom_coureur() {
            return this.inscription.get_nom_coureur(this.mainStore.is_default_mode, this.index);
        },
        is_dossard_bourse_mode() {
            return this.mainStore.dossard_bourse_mode;
        }
    },
    data() {
        return {
            deleteDialog: false
        }
    },
    methods: {
        openDeleteDialog() {
            this.deleteDialog = true;
        },
        closeDeleteDialog() {
            this.deleteDialog = false;
        },
        deleteInscription() {
            this.$emit('deleteInscription');
            this.closeDeleteDialog();
        }
    }
}
</script>

<style lang="scss" scoped></style>